










import { Tab, Tabs } from 'vant';
import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import { namespace, State } from 'vuex-class';
import * as config from './config';

Vue.use(Tab).use(Tabs);

@Component({
  components: {
    VoteList,
  },
})
export default class List extends Vue {
  // action: string = '';
  options = config.OPTHINES;
  // computed

  goToDetail(e: any) {
    this.$router.push({
      path: './DetailPage',
      query: {
        id: e.id,
        type: e.type,
      },
    });
  }
}
